import { render, staticRenderFns } from "./Tapbar.vue?vue&type=template&id=121fe3ce&"
import script from "./Tapbar.vue?vue&type=script&lang=ts&"
export * from "./Tapbar.vue?vue&type=script&lang=ts&"
import style0 from "./Tapbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports